<template>
	<div>
        <el-dialog
			:visible.sync="localDialogVisible"
			width="98%"
			top="15px"
			:before-close="handleClose"
			append-to-body>
			<div slot="title" class="">
				<h4> {{ stationId }} - {{ stationName }} </h4>
			</div>
			<div style="margin-top:-30px;">
				<div class="row">
					<div class="col-md-8 border px-2 py-2 rounded">
						<div class="table-container">
							<b-table
								striped
								hover
								:items="pagedItems"
								:fields="fields"
								:filter="filter"
								:sort-by.sync="sortBy"
								:sort-desc.sync="sortDesc"
								@filtered="onFiltered"
								@row-clicked="rowClicked"
								class="custom-table"
								:thead-row-class="'custom-table-header-row'"
								:tbody-tr-class="row => (row === selectedRow) ? 'selected-row' : 'custom-table-row'"
							>
								<template #cell(index)="data">
								{{ (currentPage - 1) * perPage + data.index + 1 }}
								</template>
								<!--
								<template #cell(DepositCount)="data">
								{{ formatNumber(data.item.DepositCount) }}
								</template>
								-->
								<template #cell(TotalValue)="data">
								{{ formatDecimal(data.item.TotalValue) }}
								</template>
								<template #cell(actions)="data">
								<el-button size="small" type="primary" @click="detailItem(data.item)">
									Detail
								</el-button>
								</template>
							</b-table>
						
							<div class="d-flex justify-content-between align-items-center mt-3">
								<div class="d-flex align-items-center">
								<label class="mr-2">{{ `Showing ${((currentPage - 1) * perPage) + 1} to ${Math.min(currentPage * perPage, totalRows)} of ${totalRows} rows` }}</label>
								<b-form-group label-class="sr-only" class="mb-0">
									<b-form-select
									v-model="perPage"
									:options="perPages"
									ref="perPageSelect"
									@shown="adjustDropdownHeight"
									></b-form-select>
								</b-form-group>
								</div>
								<div>
								<b-pagination
									v-model="currentPage"
									:total-rows="totalRows"
									:per-page="perPage"
									@input="pageChanged"
								></b-pagination>
								</div>
							</div>

							<Loader v-if="loading.table" />

						</div>
					</div>

					<div class="col-md-4">
						<div class="col-md-row">
							<div class="col-md-12 mb-4 border rounded py-2">
								<table style="font-weight: bold;" cellpadding="5">
									<tr>
										<td>ID</td>
										<td>:</td>
										<td>{{ detailId }}</td>
									</tr>
									<tr>
										<td>Deposit Info</td>
										<td>:</td>
										<td>{{ detailDepositInfo }}</td>
									</tr>
									<tr>
										<td>Cash Bag No</td>
										<td>:</td>
										<td>{{ detailBagNo }}</td>
									</tr>
								</table>
							</div>
							<div class="col-md-12 mb-3 border rounded py-2">
								<h5>Detail</h5>
								<div class="responsive table-responsive">
									<table class="table-striped table-hover" style="width:100%;">
										<thead>
											<tr style="font-weight: bold;">
												<td class="text-center py-2 border-bottom border-top">Denom</td>
												<td class="text-center py-2 border-bottom border-top">Qty</td>
												<td class="text-center py-2 border-bottom border-top">Total</td>
											</tr>
										</thead>
										<tbody>
											<tr v-for="denomItem in denomDetailData" :key="denomItem.Denom" class="border-bottom">
												<td class="text-right py-2 px-2">{{ formatNum(denomItem.Denom, 0) }}</td>
												<td class="text-center py-2 px-2">{{ formatNum(denomItem.Qty, 0) }}</td>
												<td class="text-right py-2 px-2">{{ formatNum(denomItem.Total, 0) }}</td>
											</tr>
										</tbody>
										<tfoot>
											<tr style="font-weight: bold;">
												<td class="text-right py-2 px-2">Total</td>
												<td class="text-center py-2 px-2">{{ denomTotalQty }}</td>
												<td class="text-right py-2 px-2">{{ formatNum(denomTotal, 0) }}</td>
											</tr>
										</tfoot>
									</table>
									<Loader v-if="loading.denomDetail" />
								</div>
								
							</div>
						</div>
					</div>

				</div>
			</div>
			<span slot="footer" class="dialog-footer" style="display:none;">
				<el-button @click="localDialogVisible = false">Cancel</el-button>
				<el-button type="primary" @click="localDialogVisible = false">Confirm</el-button>
			</span>
		</el-dialog>
    </div>
</template>


<script>
import Finance from '@/components/page/Finance.js'
import PieChart from '@/components/chart/Pie.js'
import { Rainbow, Rainbow3, Config, AxiosWithJar, Penanggalan } from '@/utility.js'
import ReportResultTable from '@/views/pages/ReportResultTable2.vue'
import Loader from '@/components/loader/Loader2.vue'


export default
{
	extends: Finance,
	components: { 
		Loader,
		//TodaySummaryByDateTable,
        //ReportResultTable,
        //TableTodaySummary
		//PieChart,
		//Loader,
	},

	props: {
		depositDateDetail: {
			type: String,
			default: '',
			required: false,
		},
		dialogByDateDetailVisible: {
			type: Boolean,
			default: false,
			required: false,
		},
		itemDetail: {  // Add this line
			type: Object,
			default: () => ({}),
			required: false,
		},
    },

	data(){
		return {
			selectedRow: null,
			lastSelectedRow: null,

			detailId: '-',
			detailDepositInfo: '-',
			detailBagNo: '-',

			localDialogVisible: this.dialogByDateDetailVisible,
			localDepositDate: this.depositDateDetail,

			stationId: '', //this.itemDetail.StationId,
			stationName: '', //this.itemDetail.StationName,

			denomDetailData: [],
			denomTotalQty: 0,
			denomTotal: 0,

			//Table Attr
			items: [],
			fields: [
				{ key: 'index', label: '#', sortable: false },
				{ key: 'MachineSn', label: 'Machine Sn', sortable: true, thClass: 'text-center', tdClass: 'text-center' },
				//{ key: 'MachineName', label: 'Machine Name', sortable: true, thClass: 'text-center', tdClass: 'text-center' },
				//{ key: 'StationId', label: 'Station Id', sortable: true, thClass: 'text-center', tdClass: 'text-center' },
				//{ key: 'StationName', label: 'Station Name', sortable: true, thClass: 'text-left', tdClass: 'text-left' },
				{ key: 'DepositTime', label: 'Deposit Time', sortable: true, thClass: 'text-center', tdClass: 'text-center' },
				{ key: 'DepositId', label: 'Deposit Id', sortable: true, thClass: 'text-center', tdClass: 'text-center' },
				{ key: 'DepositUser', label: 'Deposit User', sortable: true, thClass: 'text-left', tdClass: 'text-left' },
				
				{ key: 'TotalValue', label: 'Total Value', sortable: true, thClass: 'text-center', tdClass: 'text-right' },
				{ key: 'BagNo', label: 'Bag No', sortable: true, thClass: 'text-center', tdClass: 'text-center' },
				{ key: 'bagRefNo', label: 'Bag Ref No', sortable: true, thClass: 'text-center', tdClass: 'text-center' },
				{ key: 'Info', label: 'Info', sortable: true, thClass: 'text-left', tdClass: 'text-left' },
				//{ key: 'actions', label: '', sortable: false , thClass: 'text-center', tdClass: 'text-center' }
			],
			currentPage: 1,
			perPage: 10,
			filter: '',
			totalRows: 0,
			sortBy: '',
			sortDesc: false,
			perPages: [10, 15, 20],
			selectedDate: '',
			selectedMachineSn : '',
			selectedDepositCode : '',

			//loading
			loading : {
				table:false,
				isSuccess : false,

				denomDetail: false,
			},
        }
    },

    watch: {
		depositDateDetail(newVal) {
			console.log('Deposit Date Detail Dialog 2: ' + newVal);
			this.localDepositDate = newVal;
		},
		dialogByDateDetailVisible(newVal) {
			this.localDialogVisible = newVal;
		},
		localDialogVisible(newVal) {
			this.$emit('update:dialogByDateDetailVisible', newVal);
		},
		itemDetail: {
			handler(newVal, oldVal) {
				console.log('Item Detail changed:', newVal);
				//this.selectedDate = newVal.
				this.selectedMachineSn = newVal.MachineSn;
				this.stationId = newVal.StationId,
				this.stationName = newVal.StationName,

				//set empty denom detail
				this.denomDetailData = [];
				this.detailId = '-';
				this.detailDepositInfo = '-';
				this.detailBagNo = '-';
				this.denomTotalQty = 0;
				this.denomTotal = 0;

				//get data and denom detail
				this.getData();
			},
			deep: true, // Gunakan deep watcher untuk objek
		},

		//Table
		sortBy() {
			this.sortData();
		},
		sortDesc() {
			this.sortData();
		}
    }, 

    computed: {
        pagedItems() {
			const startIndex = (this.currentPage - 1) * this.perPage;
			const endIndex = startIndex + this.perPage;
			return this.items.slice(startIndex, endIndex);
		}
    },

    mounted() {
        this.$emit('childrenRoute');
		this.localDepositDate = this.depositDateDetail;
    },

    methods: { 
		//Dialog
		handleClose(done) {
			this.$confirm('Are you sure to close this dialog?')
			.then(_ => {
				done();
				//this.dialogVisible = false;
			})
			.catch(_ => {
				//this.dialogVisible = false;
			});
		},

		//Table
		getData() {
			this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/v1/cashdeposit/todaysummarybydatedetail?'
			//this.urlRequestParams+='&date-range-start='+this.date.Start
			//this.urlRequestParams+='&date-range-end='+this.date.End

			//console.log('daterange: ' + this.dateRange)
			//console.log('this.dateRange[0]: ' + this.dateRange[0])
			//console.log('this.dateRange[1]: ' + this.dateRange[1])
			//this.urlRequestParams+='&date-range-start='+ (this.dateRange ? this.dateRange[0] : 'undefined')
			//this.urlRequestParams+='&date-range-end='+ (this.dateRange ? this.dateRange[1] : 'undefined')

			//if(this.monthRange[0] != 'undefined')
			//this.urlRequestParams+='&month-range-start='+ this.monthRange[0]

			//if(this.monthRange[1] != 'undefined')
			//this.urlRequestParams+='&month-range-end='+ this.monthRange[1]

			//this.urlRequestParams+='&period='+this.period
			//this.urlRequestParams+='&plant='+this.plantno
			//this.urlRequestParams+='&stationid='+this.stationid
			this.urlRequestParams+='&date='+this.localDepositDate
			this.urlRequestParams+='&machinesn='+this.selectedMachineSn

			this.loading.table = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
			.then((response)=>{ 
				this.loading.isSuccess = true;
				this.reportdata = response.data;

				this.items = response.data.data;

				this.totalRows = this.items.length;

				this.loading.table = false;

				//get denom detail first row
				if(this.totalRows > 0) {
					this.detailId = this.items[0].Id;
					this.detailDepositInfo = this.items[0].Info;
					this.detailBagNo = this.items[0].BagNo;
					this.selectedDepositCode = this.items[0].DepositId;
					this.getDenomDetail();
				}
				
			})
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.table = false;
			})
		},
		getDenomDetail() {
			this.urlRequestParams = Config().apiURL
			this.urlRequestParams += '/v1/cashdeposit/todaysummarydenomdetail?'
			//this.urlRequestParams+='&date-range-start='+this.date.Start
			//this.urlRequestParams+='&date-range-end='+this.date.End

			//console.log('daterange: ' + this.dateRange)
			//console.log('this.dateRange[0]: ' + this.dateRange[0])
			//console.log('this.dateRange[1]: ' + this.dateRange[1])
			//this.urlRequestParams+='&date-range-start='+ (this.dateRange ? this.dateRange[0] : 'undefined')
			//this.urlRequestParams+='&date-range-end='+ (this.dateRange ? this.dateRange[1] : 'undefined')

			//if(this.monthRange[0] != 'undefined')
			//this.urlRequestParams+='&month-range-start='+ this.monthRange[0]

			//if(this.monthRange[1] != 'undefined')
			//this.urlRequestParams+='&month-range-end='+ this.monthRange[1]

			//this.urlRequestParams+='&period='+this.period
			//this.urlRequestParams+='&plant='+this.plantno
			//this.urlRequestParams+='&stationid='+this.stationid
			this.urlRequestParams+='&date='+this.localDepositDate
			this.urlRequestParams+='&machinesn='+this.selectedMachineSn
			this.urlRequestParams+='&depositcode='+this.selectedDepositCode

			this.loading.denomDetail = true;
			//this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
			.then((response)=>{ 
				//this.loading.isSuccess = true;
				this.denomDetailData = response.data.data;

				this.calculateDenomTotals();
			})
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.denomDetail = false;
			})
      },

      onFiltered(filteredItems) {
        this.totalRows = filteredItems.length;
      },
      formatNumber(value) {
        return new Intl.NumberFormat('en-US', { style: 'decimal', currency: 'USD' }).format(value);
      },
      formatDecimal(value) {
        return new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
	},
	adjustDropdownHeight() {
		const paginationHeight = this.$refs.perPageSelect.$el.offsetHeight;
        this.$refs.perPageSelect.$el.style.height = `${paginationHeight}px`;
      },
      pageChanged(newPage) {
        this.currentPage = newPage;
      },
      sortData() {
        if (this.sortBy) {
            this.items.sort((a, b) => {
            const modifier = this.sortDesc ? -1 : 1;
            const valueA = typeof a[this.sortBy] === 'string' ? parseFloat(a[this.sortBy].replace(/[^0-9.-]+/g, '')) : a[this.sortBy];
            const valueB = typeof b[this.sortBy] === 'string' ? parseFloat(b[this.sortBy].replace(/[^0-9.-]+/g, '')) : b[this.sortBy];
            if (valueA < valueB) return -1 * modifier;
            if (valueA > valueB) return 1 * modifier;
            return 0;
            });
        }
	},
		rowClicked(item) {
			console.log('Row clicked: ' + JSON.stringify(item));
			this.detailId = item.Id;
			this.detailDepositInfo = item.Info;
			this.detailBagNo = item.BagNo;
			this.selectedDepositCode = item.DepositId;
			// this.detailItem(item);
			this.lastSelectedRow = this.selectedRow;
			// Memperbarui baris yang dipilih saat ini
			this.selectedRow = item;

			this.getDenomDetail();
		},

		calculateDenomTotals() {
			this.denomTotalQty = this.denomDetailData.reduce((total, item) => total + item.Qty, 0);
			this.denomTotal = this.denomDetailData.reduce((total, item) => total + item.Total, 0);
		},


    }
        
}

</script>

<style>
.custom-table-row {
    cursor: pointer;
}
.selected-row {
    background-color: #409EFF; 
    color: white; 
}
</style>